export enum EbookStepEnum {
  DETAIL = 'DETAIL',
  SELECT_CHAPTER = 'SELECT_CHAPTER',
  MANAGE_CHAPTER = 'MANAGE_CHAPTER',
  SETTING_EBOOK = 'SETTING_EBOOK',
  EDIT_CHAPTER = 'EDIT_CHAPTER',
  CREATE_CHAPTER = 'CREATE_CHAPTER',
  PREVIEW = 'PREVIEW',
}
